import { DateTime } from "luxon";
import { Booking } from "../../../../APIDocs/apiTypes"
import { Label } from "../../components/Label"
import { useCanAccess } from "../../hooks/useUserPermissions";
import { Title } from "../../components/Title";
import { CollapsibleCard } from "../../components/CollapsibleCard";

interface BookingDetailsProps {
    booking: Booking
    disableCollapse?: boolean
}

const convertEpochMsToDateString = (epochMsString: number | undefined) => {
    return epochMsString != undefined ? DateTime.fromMillis(epochMsString).toFormat("dd/MM/yyyy") : "Not set";
}

export const BookingDetailsCard = ({ booking, disableCollapse }: BookingDetailsProps) => {
    const renderExtraSkills = useCanAccess('canSelectExtraSkills') && booking.ExtraSkills != undefined && booking.ExtraSkills.length > 0;

    const isWindowBooking = booking.BookingType === "windowBooking";
    const windowStartDate = convertEpochMsToDateString(booking.StartDate);
    const windowEndDate = convertEpochMsToDateString(booking.EndDate);
    return (
        <CollapsibleCard identifier="bookingDetails" title="Booking Details" disableCollapse={disableCollapse}>
            <div className="grid grid-cols-3 mb-4">
                <Label title="Booking Agent" text={booking.BookingAgent} className="col-start-1"/>
                <Label title="Window Booking" text={isWindowBooking ? "Yes" : "No"} className="col-start-2" />
                <Label title="Extra Skills" text={renderExtraSkills ? (booking.ExtraSkills ?? []).join(", ") : "N/A"} className="col-start-3" />

                <Label title="Booking Date and Time" text={booking.BookingDateTime} className="col-start-1" />
                <Label title="Window Start Date" text={!booking.WindowScheduleDate && isWindowBooking  ? windowStartDate : "N/A"} className="col-start-2" />
                <Label title="Assigned Operative" text={booking.AssignedOperative} className="col-start-3" />

                <Label title="Appointment Time" text={booking.ScheduledDate} className="col-start-1" />
                {<Label title="Window End Date" text={!booking.WindowScheduleDate && isWindowBooking ? windowEndDate : "N/A"} className="col-start-2" />}
                <Label title="Site Address ID" text={booking.AddressDetails?.SiteAddressId ? `${booking.AddressDetails?.SiteAddressId}` : ''} className="col-start-3" />

                <Label title="Appointment Band" text={booking.AppointmentBandDescription} className="col-start-1" />
                <Label title="Job Type Code" text={booking.JobTypeCode} className="col-start-2" />
                <Label title="Source" text={booking.Source} className="col-start-3" />

                <Label title="Additional Notes" text={booking.AdditionalNotes ?? "None"} className="col-span-full"/>
                <Label title="Job Comments" text={booking.JobComments ?? ""} className="col-span-full"/>
            </div>
            <Title className="text-center mb-2 pb-2 border-b border-b-soft-elevation-0" text="Communication Details" />
            <div className="grid grid-cols-2 xl:grid-cols-3">
                <Label title="SMS Number" text={booking.CommunicationPreferences?.SmsNumber ?? "None"} />
                <Label title="Email Address" text={booking.CommunicationPreferences?.EmailAddress ?? "None"} />
                <Label title="RAMS Email Address" text={booking.CommunicationPreferences?.RamsEmailAddress ?? "None"} />
                <Label title="SMS Confirmation Required" text={booking.CommunicationPreferences?.SmsConfirmation ? "Yes" : "No"} />
                <Label title="Email Confirmation" text={booking.CommunicationPreferences?.EmailConfirmation ? "Yes" : "No"} />
                <Label title="RAMS Required" text={booking.CommunicationPreferences?.RamsRequired ? "Yes" : "No"} />
                <Label title="SMS Reminder" text={booking.CommunicationPreferences?.SmsReminder ? "Yes" : "No"} />
                <Label title="Email Reminder" text={booking.CommunicationPreferences?.EmailReminder ? "Yes" : "No"} />
                <Label title="Site Induction Required" text={booking.SiteInductionRequired ? "Yes" : "No"} />
            </div>
        </CollapsibleCard>
    )
}
